export default "__VITE_ASSET__CRbTaiAD__"